import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DynamicStyle } from 'app/infrastructure/model/classes/dynamicStyle.class';
import { DynamicStyleHelper } from 'app/helpers/components/dynamicStyle/dynamicStyleHelper';

@Component({
    selector: 'dynamic-style',
    templateUrl: './dynamicStyle.component.html',
    styleUrls: ['./dynamicStyle.component.css'],
    encapsulation: ViewEncapsulation.None
  })
  export class DynamicStyleComponent{
    dynamicCSS = '';
    dynamicClasses = '';
    titleCSS = '';
    titleClasses = '';

    @Input() context: any;
    
    constructor() {}

    init(): void {
      if( this.context && this.context.selectedDesigner && this.context.selectedDesigner.controlContext ) {
        const fromContext = this.context.selectedDesigner.controlContext.dynamicStyle;
        this.dynamicCSS = (fromContext && fromContext.dynamicCSS) ? DynamicStyleHelper.stringifyStyles(fromContext.dynamicCSS) : '';
        this.dynamicClasses = (fromContext && fromContext.dynamicClasses) ? fromContext.dynamicClasses : '';
        this.titleCSS = (fromContext && fromContext.titleCSS) ? DynamicStyleHelper.stringifyStyles(fromContext.titleCSS) : '';
        this.titleClasses = (fromContext && fromContext.titleClasses) ? fromContext.titleClasses : '';
      }
    }

    sendDynamicStyle() : any {
      let dynStyle = new DynamicStyle()
      dynStyle.dynamicCSS = DynamicStyleHelper.parseStyles(this.dynamicCSS as string)
      dynStyle.dynamicClasses = this.dynamicClasses
      dynStyle.titleCSS = DynamicStyleHelper.parseStyles(this.titleCSS as string)
      dynStyle.titleClasses = this.titleClasses
      return dynStyle;
    }
  }


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/shared/dynamicStyle.component.ts